// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'promise-polyfill/src/polyfill';
import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import VeeValidate from 'vee-validate';
import globals from './../components/common/globals';
import messages from './../locale/angelsoft/messages';
import commonModule from './../modules/common-b2c';
import searchBrowseModule from './../modules/search-browse-b2c';
import viewSiteContentModule from './../modules/view-site-content-b2c';
import pdpModule from './../modules/pdp-b2c';
import accessCustomerServiceModule from './../modules/access-customer-service-b2c';
import accessibeMixin from '../components/common/mixins/accessibe-mixin';
import nfrModule from './../modules/nfr';
import '../components/common/directives/directives';
/** All flags are coming from backoffice.
 * import siteConfig from '../config/sparkle-config';
 *  */
import variables from './variables';

const config = {
  delay: 100,
};

Vue.use(VeeValidate, config);
Vue.use(VueLazyload, {
  lazyComponent: true,
});
Vue.config.productionTip = false;
Vue.config.keyCodes = {
  // Enter or space Capturing
  'enter-space': [13, 32],
};
// Vue.config.performance = true;
// Vue.config.devtools = true;
const vm = new Vue({
  el: '#angelsoft',
  data: {
    messages: messages['en-US'],
    globals,
    // siteConfig,
    variables,
    cartExists: true,
  },
  mixins: [
    commonModule,
    searchBrowseModule,
    viewSiteContentModule,
    pdpModule,
    accessCustomerServiceModule,
    nfrModule,
    accessibeMixin,
  ],
  components: {},
  mounted() {
    /**
     * setting site specific variables
     */
    this.globals.siteVariables = this.variables;
    /* global $ */
    /* eslint no-undef: "error" */
  },
});

window.vm = vm;
Vue.config.errorHandler = (err, vm1, info) => {
  vm.sendToTrackJS(err, vm1, info);
};



// WEBPACK FOOTER //
// ./src/angelsoft/angelsoft.js